<template>
  <div>
    <!--BACKGROUOND OPACITY-->
    <div class="fade show backdrop"></div>

    <div class="modal d-flex flex-column">
      <!--<div class="modal-dialog w-100 h-100 m-0" style="max-width: inherit;">-->
      <div class="modal-body d-flex mb-0">
        <div class="sidebar" v-bind:class="{ 'd-none': user.seller !== 6 }">
          <b-list-group>
            <!--<b-list-group-item
                v-for="opt in menu"
                v-if="config[opt] && config[opt].visible"
                :key="opt"
                :variant="(opt === curOption) ? 'secondary' : ''"
                :button="true"
                @click="curOption = opt"
                style="cursor: pointer"
                class="d-flex justify-content-between align-items-center text-capitalize"
              >
                <span v-text="_trans(opt)"></span>
                <b-badge v-if="opt === curOption" variant="transparent" pill>
                  <i class="di di-arrow-right"></i>
                </b-badge>
              </b-list-group-item>
              <b-list-group-item
                v-if="user.admin"
                :variant="('admin' === curOption) ? 'secondary' : ''"
                :button="true"
                @click="curOption = 'admin'"
                style="cursor: pointer"
                class="d-flex justify-content-between align-items-center text-capitalize"
              >
                <span v-text="_trans('Admin')"></span>
                <b-badge v-if="'admin' === curOption" variant="transparent" pill>
                  <i class="di di-arrow-right"></i>
                </b-badge>
              </b-list-group-item>-->
            <b-list-group-item
              v-if="user.admin || user.seller === 6"
              :variant="('logs' === curOption) ? 'secondary' : ''"
              :button="true"
              style="cursor: pointer"
              class="d-flex justify-content-between align-items-center text-capitalize"
              @click="curOption = 'logs'"
            >
              <span v-text="_trans('Logs')"></span>
              <b-badge v-if="'logs' === curOption" variant="transparent" pill>
                <i class="di di-arrow-right"></i>
              </b-badge>
            </b-list-group-item>

            <b-list-group-item
              v-if="user.admin || user.seller === 6"
              :variant="('logs' === curOption) ? 'secondary' : ''"
              :button="true"
              style="cursor: pointer"
              class="d-flex justify-content-between align-items-center text-capitalize"
              @click="curOption = 'galleries'"
            >
              <span v-text="_trans('Galleries roles')"></span>
              <b-badge v-if="'galleries' === curOption" variant="transparent" pill>
                <i class="di di-arrow-right"></i>
              </b-badge>
            </b-list-group-item>
          </b-list-group>
        </div>
        <div class="content p-3 pb-5">
          <h3 class="text-capitalize text-info mb-5" v-text="_trans(curOption)"></h3>
          <!--<template v-if="curOption === 'preferences'">
              <div class="my-3">
                <label v-text="_trans('Catalog defalut')"></label>
                <b-form-input v-model="config.preferences.defaultcatalog"></b-form-input>
              </div>

              <div class="my-3">
                <label v-text="_trans('Forced catalog')"></label>
                <b-form-input v-model="config.preferences.forcedcatalog"></b-form-input>
              </div>

              <div class="form-group">
                <label>
                  <span v-text="_trans('Language')"></span></label>
                  <select v-model="config.preferences.language" class="form-control">
                    <option v-for="lang in config.preferences.available_languages" :key="lang" v-text="lang"></option>
                  </select>
              </div>
              <div class="form-group">
                <label>
                  <span v-text="_trans('Currency')"></span></label>
                  <select v-model="config.preferences.currency" class="form-control">
                    <option
                      v-for="curr in config.preferences.available_currencies"
                      :key="curr"
                      :value="curr"
                      v-text="curr +' '+ currencies[curr].symbol_native"
                    ></option>
                  </select>
              </div>
            </template>
            <template v-if="curOption === 'measures'">
              <div class="form-group">
                <label>
                  <span v-text="_trans('Length')"></span></label>
                  <select v-model="config.measures.length" class="form-control">
                    <option
                      v-for="cod in config.measures.available_lengths"
                      :key="cod"
                      :value="cod"
                      v-text="_unitShortCode(cod)"
                    ></option>
                  </select>

              </div>
              <div class="form-group">
                <label>
                  <span v-text="_trans('Weight')"></span>
                </label>
                <select v-model="config.measures.weight" class="form-control">
                  <option
                    v-for="cod in config.measures.available_weights"
                    :key="cod"
                    :value="cod"
                    v-text="_unitShortCode(cod)"
                  ></option>
                </select>
              </div>
              <div class="form-group">
                <label>
                  <span v-text="_trans('Volume')"></span>
                </label>
                <select v-model="config.measures.volume" class="form-control">
                  <option
                    v-for="cod in config.measures.available_volumes"
                    :key="cod"
                    :value="cod"
                    v-text="_unitShortCode(cod)"
                  ></option>
                </select>
              </div>
            </template>
            <template v-if="curOption === 'toolbar'">
              <b-row :no-gutters="true">
                <b-col cols="1" class="px-2 my-2" v-for="key in Object.keys(config[curOption])" v-if="key !== 'visible'" :key="key">
                  <b-form-checkbox v-model="config[curOption][key].visible">
                    <span class="text-capitalize" v-text="key"></span>
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </template>
            <template v-if="curOption === 'engines'">
              <div v-if="config[curOption].collision" class="my-3">
                <label><span v-text="_trans('Collision')"></span></label>
                <b-form-input v-model="config[curOption].collision"></b-form-input>
              </div>

              <div v-if="config[curOption]['snapDist']" class="border p-3 my-3">
                <h4 class="mb-3" v-text="_trans('Snap distances')"></h4>
                <div v-if="config[curOption]['snapDist'].magic" class="my-1">
                  <label><span v-text="_trans('Magic link')"></span></label>
                  <b-form-input v-model="config[curOption].magic"></b-form-input>
                </div>
                <div v-if="config[curOption]['snapDist'].wall" class="my-1">
                  <label><span v-text="_trans('Wall')"></span></label>
                  <b-form-input v-model="config[curOption].wall"></b-form-input>
                </div>
                <div v-if="config[curOption]['snapDist'].snap" class="my-1">
                  <label><span v-text="_trans('Snap')"></span></label>
                  <b-form-input v-model="config[curOption].snap"></b-form-input>
                </div>
              </div>

              <div v-if="config[curOption]['3d']" class="border my-3 p-3">
                <h4 class="mb-3" v-text="_trans('3D Engine')"></h4>
                <div v-if="config[curOption]['3d'].zoomSensitivity" class="my-1">
                  <label><span v-text="_trans('Zoom Sensitivity')"></span></label>
                  <b-form-input v-model="config[curOption]['3d'].zoomSensitivity"></b-form-input>
                </div>
                <div v-if="config[curOption]['3d'].activeGrid" class="my-1">
                  <label><span v-text="_trans('Active Grid')"></span></label>
                  <b-form-input v-model="config[curOption]['3d'].activeGrid"></b-form-input>
                </div>
                <div v-if="config[curOption]['3d'].activeLines" class="my-1">
                  <b-form-checkbox v-model="config[curOption]['3d'].activeLines" :value="1" :unchecked-value="0">
                    <span class="text-capitalize" v-text="_trans('Active Lines')"></span>
                  </b-form-checkbox>
                </div>
                <div v-if="config[curOption]['3d'].moveArrowSize" class="my-1">
                  <label><span v-text="_trans('Move Arrow Size')"></span></label>
                  <b-form-input v-model="config[curOption]['3d'].moveArrowSize"></b-form-input>
                </div>
                <div v-if="config[curOption]['3d'].rotationArrowSize" class="my-1">
                  <label><span v-text="_trans('Rotation ArrowSize')"></span></label>
                  <b-form-input v-model="config[curOption]['3d'].rotationArrowSize"></b-form-input>
                </div>
                <div v-if="config[curOption]['3d'].boundinBoxPointSize" class="my-1">
                  <label><span v-text="_trans('Boundin Box Point Size')"></span></label>
                  <b-form-input v-model="config[curOption]['3d'].boundinBoxPointSize"></b-form-input>
                </div>
                <div v-if="config[curOption]['3d'].showObjectsQuote" class="my-1">
                  <b-form-checkbox v-model="config[curOption]['3d'].showObjectsQuote">
                    <span class="text-capitalize" v-text="_trans('Show quotes')"></span>
                  </b-form-checkbox>
                </div>
                <div v-if="config[curOption]['3d'].showAxisArrows" class="my-1">
                  <b-form-checkbox v-model="config[curOption]['3d'].showAxisArrows">
                    <span class="text-capitalize" v-text="_trans('Show axis arrows')"></span>
                  </b-form-checkbox>
                </div>
                <div v-if="config[curOption]['3d'].showRotationArrow" class="my-1">
                  <b-form-checkbox v-model="config[curOption]['3d'].showRotationArrow">
                    <span class="text-capitalize" v-text="_trans('Show rotation arrows')"></span>
                  </b-form-checkbox>
                </div>
                <div v-if="config[curOption]['3d'].enableRedLines" class="my-1">
                  <b-form-checkbox v-model="config[curOption]['3d'].enableRedLines">
                    <span class="text-capitalize" v-text="_trans('Enable red lines')"></span>
                  </b-form-checkbox>
                </div>
                <div v-if="config[curOption]['3d'].enableForcedGamma" class="my-1">
                  <b-form-checkbox v-model="config[curOption]['3d'].enableForcedGamma">
                    <span class="text-capitalize" v-text="_trans('Enable forced gamma')"></span>
                  </b-form-checkbox>
                </div>
                <div v-if="config[curOption]['3d'].enableSelectShadow" class="my-1">
                  <b-form-checkbox v-model="config[curOption]['3d'].enableSelectShadow">
                    <span class="text-capitalize" v-text="_trans('Enable select shadow')"></span>
                  </b-form-checkbox>
                </div>
              </div>

              <div v-if="config[curOption]['2d']" class="border my-3 p-3">
                <h4 class="mb-3" v-text="_trans('2D Engine')"></h4>
                <div v-if="config[curOption]['2d'].style" class="my-1">
                  <label><span v-text="_trans('Selected color')"></span></label>
                  <b-form-input v-model="config[curOption]['2d'].style.selObjColor"></b-form-input>
                  <label class="mt-3"><span v-text="_trans('Deselected color')"></span></label>
                  <b-form-input v-model="config[curOption]['2d'].style.deselObjColor"></b-form-input>
                  <label class="mt-3"><span v-text="_trans('Multiselected color')"></span></label>
                  <b-form-input v-model="config[curOption]['2d'].style.multiselObjColor"></b-form-input>
                </div>
              </div>
            </template>
            <template v-if="curOption === 'print options'">
              <b-row :no-gutters="true">
                <b-col cols="1" class="px-2 my-2" v-for="print in config[curOption].prints" :key="print.stn">
                  <b-form-checkbox v-model="print.value" :value="1" :unchecked-value="0">
                    <span class="text-capitalize" v-text="print.des"></span>
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </template>
            <template v-if="curOption === 'renderfarm'">

              <div class="my-3">
                <label><span v-text="_trans('Render Farm URL')"></span></label>
                <b-form-input v-model="config['renderfarm'].rfServer"></b-form-input>
              </div>

              <b-form-checkbox v-model="config['renderfarm'].rfAuthHidden" class="my-3">
                <span class="text-capitalize" v-text="_trans('Hidden login')"></span>
              </b-form-checkbox>
            </template>
            <template v-if="curOption === 'admin'">
              <label>
                <span v-text="_trans('Back Site')"></span></label>
              <b-form-input class="my-3" v-model="config.backsite"></b-form-input>
              <select v-model="config.backsite" class="form-control my-3">
                <option
                  v-for="cod in config.sites"
                  :key="cod"
                  :value="cod"
                  v-text="cod"
                ></option>
              </select>
              <b-form-checkbox v-model="config.debug" class="my-3">
                <span class="text-capitalize" v-text="_trans('debug')"></span>
              </b-form-checkbox>
              <b-form-checkbox v-model="config.isguest" class="my-3">
                <span class="text-capitalize" v-text="_trans('Guest accepted')"></span>
              </b-form-checkbox>
            </template>-->

          <!--GALLERIES-->
          <template v-if="curOption === 'galleries'">

            <b-row>
              <b-col cols="4">
                <b-form-select
                  v-model="catalog"
                  :placeholder="_trans('Select catalog')"
                  :label-field="_trans('Catalog')"
                  @change="loadGalleryTable"
                >
                  <option
                    v-for="x in user.cats"
                    :key="x.cod"
                    :value="x.cod"
                    v-text="x.cod"
                  >
                  </option>
                </b-form-select>
              </b-col>
              <b-col>
                <div v-if="catalog && galleryPriviledges">
                  <b-table
                    head-variant="dark"
                    primary-key="pSellerLevel"
                    :fields="[
                      { label: _trans('Seller level'), key: 'pSellerLevel', sortable: false, variant: 'warning' },
                      { label: _trans('Main'), key: 'pMain', sortable: false },
                      { label: _trans('Country'), key: 'pCountry', sortable: false },
                      { label: _trans('Brand'), key: 'pChain', sortable: false },
                      { label: _trans('Sellers'), key: 'pSeller', sortable: false },
                      { label: _trans('Shop'), key: 'pShop', sortable: false },
                      { label: _trans('User'), key: 'pUsers', sortable: false },
                    ]"
                    :items="galleryPriviledges"
                  >
                    <template v-slot:cell()="data">
                      <strong v-if="data.field.key === 'pSellerLevel'" v-text="data.value"></strong>
                      <b-form-select v-else v-model="galleryPriviledges[data.index][data.field.key]">
                        <option value="X" v-text="_trans('Not visible')"></option>
                        <option value="R" v-text="_trans('Read only')"></option>
                        <option value="C" v-text="_trans('Can create')"></option>
                      </b-form-select>
                    </template>
                  </b-table>
                  <b-button variant="primary" @click="setGalleryPriv" v-text="_trans('Update priviledges')"></b-button>
                </div>
              </b-col>
            </b-row>
          </template>

          <!--LOGS-->
          <template v-if="curOption === 'logs'">
            <v-client-table :data="logs" :columns="logsColumns" :options="logsTableOpt">
              <template v-slot:time="props">
                <span v-text="props.row.ms + ' ms'"></span>
              </template>
              <template v-slot:response="props">
                <div v-if="!props.row.error">
                  <span v-if="typeof props.row.body === 'string'" v-text="props.row.body"></span>
                  <span v-else v-text="_trans('Json response')"></span>
                  <!--<b-button
                      v-else
                      variant="secondary"
                      size="xs"
                      @click="showResponse(props.row.body)"
                      v-text="_trans('Show response')"
                    ></b-button>-->
                </div>
                <span v-else class="text-danger" v-text="props.row.error"></span>
              </template>
              <template v-slot:message="props">
                <pre
                  style="max-width: 50vw; max-height: 350px; overflow-y: auto; overflow-x: auto"
                  class="text-info"
                  v-text="props.row.message"
                >
                </pre>
              </template>
              <template v-slot:date="props">
                <span>{{ props.row.date | moment('D MMM YYYY HH:mm') }}</span>
              </template>
            </v-client-table>
          </template>
          <!--<pre v-text="config[curOption]"></pre>-->
        </div>
        <!--</div>-->
      </div>

      <!--FOOTER-->
      <div class="modal-footer d-flex flex-row bg-info">
        <div v-if="user.admin || user.seller === 6" class="mr-auto">
          <b-button variant="danger" @click="clearDM()" v-text="_trans('Clear Devmaster')"></b-button>
          <b-button variant="warning" @click="refreshUser()" v-text="_trans('Refresh User')"></b-button>
          <b-button @click="saveTrans()">Save translations</b-button>
        </div>

        <!--<span v-if="changesFirstTime" class="text-danger" v-text="_trans('You must reload the page to apply settings')"></span>-->
        <div>
          <!--<b-button variant="secondary" @click="resetDefault($event)" v-text="_trans('Reset default')"></b-button>-->
          <!--<b-button variant="secondary" :disabled="!changes" @click="resetChanges($event)" v-text="_trans('Reset')"></b-button>-->
          <b-button variant="secondary" @click="$emit('close', $event)" v-text="_trans('Cancel')"></b-button>
          <!--<b-button variant="info" :disabled="!changes" @click="apply($event)" v-text="_trans('Apply')"></b-button>-->
          <!--<b-button v-if="changes" @click="ok($event)" variant="primary" v-text="_trans('Ok')"></b-button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { App } from '@3cad/nextcore';
import { NextApiClient, GalleryAPI, QueryAPI, ServerAPI } from '@3cad/nextcore';
import { utils } from '@3cad/nextcore';
let { loadJson, toLowerCaseKey } = utils
export default {
    name: 'Preferences',
    components: {},
    props: {},
    data() {
        return {
            config: null,
            curOption: 'logs',
            menu: [
                // 'preferences',
                // 'measures',
                // 'toolbar',
                // 'engines',
                // 'print options',
                // 'renderfarm'
            ],
            logsColumns: ['service', 'funct', 'response', 'message', 'time', 'date'],
            logs: [],
            catalog: null,
            galleryPriviledges: [],
            logsTableOpt: {
                perPage: 5,
                perPageValues: [5, 10],
                headings: {
                    funct: col => { return this._trans('function') },
                    date: col => { return this._trans('date') },
                    service: col => { return this._trans('service') },
                    message: col => { return this._trans('message') },
                    response: col => { return this._trans('response') },
                    time: col => { return this._trans('response time') }
                },
                orderBy: {
                    column: 'date',
                    ascending: false
                }
            },
            changes: false,
            changesFirstTime: false
        }
    },
    computed: {

    },
    watch: {
        config: {
            handler: function(newVal) {
                this.changes = JSON.stringify(newVal) !== localStorage['3cad.config'];
                if(this.changes)
                    this.changesFirstTime = true;
            },
            deep: true
        },
        curOption(newVal) {
            switch (newVal) {
                case 'galleries':

                    this.loadGalleryTable();
                    break;
            }
        }
    },
    created() {
        window.addEventListener('keyup',this._keyup);
        this.config = this._copy(App.getConfig());
        this.logs = NextApiClient.getLogs();
    },
    mounted() {},
    destroyed() {
        window.removeEventListener('keyup', this._keyup);
    },
    methods: {
        resetDefault() {
            loadJson('./config/' + process.dau._CONFIG + '?v=' + (new Date()).getTime())
                .then( json => {
                    json.dclass = toLowerCaseKey(json.dclass);
                    this.config = this._copy(json);
                })
                .catch(err => {
                    throw err;
                })
        },
        resetChanges() {
            this.config = this._copy(App.getConfig());
        },
        showResponse(res) {
            console.log(res);
        },
        loadGalleryTable() {
            if(this.catalog) {
                GalleryAPI.getCreationPriviledges(this.catalog, json => {
                    if(json.privMatrixMine)
                        this.galleryPriviledges = json.privMatrixMine;
                }, err => {
                    throw err;
                })
            }
            else {
                // alert('Select a valid catalog');
            }
        },
        setGalleryPriv() {
            GalleryAPI.setCreationPriviledges(this.catalog, this.galleryPriviledges,json => {
                if(json.privMatrixMine) {
                    this.galleryPriviledges = json.privMatrixMine;
                    this.$3cadInfo({
                        title: this._trans('Gallery pridvileges'),
                        body: this._trans('Table updated')
                    })
                }
            }, err => {
                throw err;
            })
        },
        refreshUser() {
            QueryAPI.sessionEnd();
        },
        clearDM() {
            ServerAPI.reloadAmbiente();
        },
        saveTrans() {
            App.translator.saveTranslations();
        },
        apply() {
            App.setConfig(this.config);
        },
        ok() {
            this.apply();
            this.$emit('close');
        },
        _keyup(e) {
            if(e && e.code === 'Escape')
                this.$emit('close', e);
        },
        _copy(json) {
            return JSON.parse(JSON.stringify(json));
        }
    }
}
</script>

<style scoped lang="scss">
  .backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1040;
    background-color: #cccccc;

    &.fade {
      opacity: 0;
    }

    &.show {
      opacity: 0.8;
    }
  }

  .modal {
    .modal-body {
      overflow: hidden;
      background-color: $secondary;
    }
    .sidebar {
      height: 100%;
      width: 400px;
      overflow-y: auto;
    }

    .content {
      position: relative;
      height: 100%;
      width: 100%;
      overflow-y: auto;
      background-color: rgba(255,255,255,.8);
    }

    .settings-footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/app/base/settings.vue